import { render, staticRenderFns } from "./step-cost-state.vue?vue&type=template&id=fa0c354c"
import script from "./step-cost-state.vue?vue&type=script&lang=ts"
export * from "./step-cost-state.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports